import gql from 'graphql-tag';

export const condominiumMaintenanceModeFragment = gql`
  fragment condominiumMaintenanceModeParts on CondominiumMaintenanceMode {
    id
    placeId
    placeName
    workOrderId
    createdByPersonContextId
    creationDate
    durationInSeconds
  }
`;

export const maintenancePropagationPlaceFragment = gql`
  fragment maintenancePropagationPlaceParts on MaintenancePropagationPlace {
    placeId
    reason
  }
`;
